module.exports = __webpack_public_path__ + "images/category_lp/common/store_images/toys_king_9755084d7e1c6fe9764b704389e4d3a9.png";